import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Philosophy from "@/pages/Philosophy";
import Contact from "@/pages/Contact";
import { HubPage } from "@/pages/HubPage";
import { DetailPage } from "@/pages/DetailPage";
import NotFound from "@/pages/NotFound";
import Book from "@/pages/Book";
import { FormulareHub, FormulareDetail } from "@/pages/Formulare";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PatientLogin from "@/pages/portal/PatientLogin";
import PatientPortal from "@/pages/portal/PatientPortal";
import { useAuth } from "@/context/AuthContext";
import { STAGE_IMAGES, EXPERTISE_IMAGES, HUB_IMAGES } from "@/lib/assets";

const Loading = () => <div className="flex min-h-screen items-center justify-center bg-sand text-deep-ink/60">Loading…</div>;

const RoleRoute = ({ roles, redirect, children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user || (roles && !roles.includes(user.role))) return <Navigate to={redirect} replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/contact" element={<Contact />} />

            <Route
              path="/hormonal-health"
              element={<HubPage ns="hormonalHealth" itemsKey="hormonalHealth.items" base="/hormonal-health" heroImage={HUB_IMAGES.hormonalHealth} testId="hormonal-health-hub" />}
            />
            <Route
              path="/hormonal-health/:slug"
              element={<DetailPage ns="hormonalHealth" itemsKey="hormonalHealth.items" base="/hormonal-health" baseLabelKey="nav.hormonalHealth" />}
            />

            <Route
              path="/fertility-pregnancy"
              element={<HubPage ns="fertilityPregnancy" itemsKey="fertilityPregnancy.items" base="/fertility-pregnancy" heroImage={HUB_IMAGES.fertilityPregnancy} testId="fertility-pregnancy-hub" />}
            />
            <Route
              path="/fertility-pregnancy/:slug"
              element={<DetailPage ns="fertilityPregnancy" itemsKey="fertilityPregnancy.items" base="/fertility-pregnancy" baseLabelKey="nav.fertilityPregnancy" />}
            />

            <Route
              path="/menopause-aging"
              element={<HubPage ns="menopauseAging" itemsKey="menopauseAging.items" base="/menopause-aging" heroImage={HUB_IMAGES.menopauseAging} testId="menopause-aging-hub" />}
            />
            <Route
              path="/menopause-aging/:slug"
              element={<DetailPage ns="menopauseAging" itemsKey="menopauseAging.items" base="/menopause-aging" baseLabelKey="nav.menopauseAging" />}
            />

            <Route
              path="/preventive-medicine"
              element={<HubPage ns="preventiveMedicine" itemsKey="preventiveMedicine.items" base="/preventive-medicine" heroImage={HUB_IMAGES.preventiveMedicine} testId="preventive-medicine-hub" />}
            />
            <Route
              path="/preventive-medicine/:slug"
              element={<DetailPage ns="preventiveMedicine" itemsKey="preventiveMedicine.items" base="/preventive-medicine" baseLabelKey="nav.preventiveMedicine" />}
            />

            {/* Legacy nav (delisted from the header menu but kept live to avoid breaking existing links) */}
            <Route
              path="/life-stages"
              element={<HubPage ns="lifeStages" itemsKey="lifeStages.items" base="/life-stages" imageMap={STAGE_IMAGES} heroImage={HUB_IMAGES.lifeStages} testId="life-stages-hub" />}
            />
            <Route
              path="/life-stages/:slug"
              element={<DetailPage ns="lifeStages" itemsKey="lifeStages.items" base="/life-stages" baseLabelKey="nav.lifeStages" imageMap={STAGE_IMAGES} />}
            />

            <Route
              path="/expertise"
              element={<HubPage ns="expertise" itemsKey="expertise.items" base="/expertise" heroImage={HUB_IMAGES.expertise} testId="expertise-hub" />}
            />
            <Route
              path="/expertise/:slug"
              element={<DetailPage ns="expertise" itemsKey="expertise.items" base="/expertise" baseLabelKey="nav.expertise" imageMap={EXPERTISE_IMAGES} />}
            />

            <Route
              path="/approach"
              element={<HubPage ns="approach" itemsKey="approach.pages" base="/approach" testId="approach-hub" />}
            />
            <Route
              path="/approach/:slug"
              element={<DetailPage ns="approach" itemsKey="approach.pages" base="/approach" baseLabelKey="nav.approach" />}
            />

            <Route
              path="/patient-service"
              element={<HubPage ns="patientService" itemsKey="patientService.pages" base="/patient-service" heroImage={HUB_IMAGES.patientService} testId="patient-service-hub" />}
            />
            <Route
              path="/patient-service/:slug"
              element={<DetailPage ns="patientService" itemsKey="patientService.pages" base="/patient-service" baseLabelKey="nav.patientService" />}
            />


            <Route
              path="/legal/:slug"
              element={<DetailPage ns="legal" itemsKey="legal.pages" base="/" baseLabelKey="nav.home" kind="legal" />}
            />

            <Route path="/formulare" element={<FormulareHub />} />
            <Route path="/formulare/:slug" element={<FormulareDetail />} />

            <Route path="/book" element={<Book />} />
            <Route path="/booking/requested" element={<PaymentSuccess />} />

            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RoleRoute roles={["admin", "physician", "reception"]} redirect="/admin/login"><AdminDashboard /></RoleRoute>} />

          <Route path="/portal/login" element={<PatientLogin />} />
          <Route path="/portal" element={<RoleRoute roles={["patient"]} redirect="/portal/login"><PatientPortal /></RoleRoute>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
